import { formatDistanceToNow, format, parseISO } from "date-fns";

export function timeAgo(iso) {
  if (!iso) return "";
  try {
    return formatDistanceToNow(parseISO(iso), { addSuffix: true });
  } catch {
    return "";
  }
}

export function fmtDate(iso) {
  if (!iso) return "";
  try {
    return format(parseISO(iso), "d MMM yyyy, HH:mm");
  } catch {
    return "";
  }
}

export function roleBadge(role) {
  if (role === "admin") return { label: "Admin", cls: "badge-role-admin" };
  if (role === "moderator") return { label: "Mod", cls: "badge-role-mod" };
  return null;
}

export function initials(name) {
  if (!name) return "?";
  return name.trim().slice(0, 2).toUpperCase();
}
